import { TranslateLoader, MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { of } from 'rxjs';

import de from './shared/i18n/de-DE';
import en from './shared/i18n/en-GB';
import es from './shared/i18n/es-ES';
import fr from './shared/i18n/fr-FR';
import it from './shared/i18n/it-IT';
import pl from './shared/i18n/pl-PL';

export class StaticLoader implements TranslateLoader {
	getTranslation(lang: string) {
		let langObj;
		switch (lang) {
		case 'fr':
			langObj = fr;
			break;
		case 'es':
			langObj = es;
			break;
		case 'de':
			langObj = de;
			break;
		case 'pl':
			langObj = pl;
			break;
		case 'it':
			langObj = it;
			break;
		// case 'en':
		default:
			langObj = en;
			break;
		}
		return of(langObj);
	}
}

export class StaticMissingTranslationHandler implements MissingTranslationHandler {
	handle(params: MissingTranslationHandlerParams) {
		console.error(`"${ params.key }" translation is missing !!`);
		return `[[[${ params.key }]]]`;
	}
}
